import { Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { ReportBaseService } from './report-base.service';

import { UtilsService } from './utils.service';
import { WarehouseTransfers_DatasourceService } from './WarehouseTransfers.datasource.index';

interface IWarehouseTransfers_outbound_pick_slip_reportServiceInParams {
  orderId: number}

interface IWarehouseTransfers_outbound_pick_slip_reportServiceData {
  Owner?: { result?: { Id?: number, Project?: { Id?: number, Owner?: { Id?: number, OwnersContactsLookup?: { ContactId?: number, Contact?: { Id?: number, Address?: { City?: string, Country?: string, Line1?: string, Line2?: string, PostalCode?: string, State?: string } } }[] } } } }
  ShipTo?: { result?: { AttentionOf?: string, FirstName?: string, LastName?: string, Line1?: string, Line2?: string, City?: string, State?: string, PostalCode?: string, Country?: string, PrimaryTelephone?: string, OrderId?: number } }
  PickSlipHeader?: { result?: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, RequestedDeliveryDate?: string, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ExpectedDate?: string, FobLocation?: string, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Notes?: string, ShippedDate?: string, Wave?: { Id?: number, PickSlips?: { Id?: number, LookupCode?: string }[], Warehouse?: { Name?: string } }, Carrier?: { Name?: string } } }[], Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }[] }
  PickSlipDetail?: { result?: { Id?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, MaterialId?: number, OrderId?: number, Shipment?: { Id?: number, ExpectedDate?: string, FobLocation?: string, LookupCode?: string, ShippedDate?: string, Wave?: { Id?: number, PickSlips?: { LookupCode?: string }[], Warehouse?: { Name?: string } } }, ExpectedSourceLicensePlate?: { LookupCode?: string, Location?: { Name?: string } }, ExpectedSourceLocation?: { Name?: string }, Material?: { Id?: number, Description?: string, LookupCode?: string }, PickSlip?: { LookupCode?: string }, Lot?: { LookupCode?: string }, DimensionsUOM?: { Name?: string, Short_name?: string }, OrderLine?: { Marks?: string, Notes?: string, Material?: { Id?: number, Description?: string, LookupCode?: string } }, Order?: { Id?: number, CreatedSysDateTime?: string, RequestedDeliveryDate?: string }, ExpectedPackagedPack?: { Name?: string, ShortName?: string }, MaterialWeights?: { MaterialId?: number, PackagingId?: number, BasePackagingId?: number, BasePackagingQuantity?: number, ShippingVolume?: number, ShippingWeight?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number } }[] }
}

@Injectable({ providedIn: 'root' })
export class WarehouseTransfers_outbound_pick_slip_reportService extends ReportBaseService<IWarehouseTransfers_outbound_pick_slip_reportServiceInParams, IWarehouseTransfers_outbound_pick_slip_reportServiceData> {

  protected reportReferenceName = 'outbound_pick_slip_report';
  protected appReferenceName = 'WarehouseTransfers';

  constructor(
    $utils: UtilsService,
    private $datasources: WarehouseTransfers_DatasourceService,
    ) {
      super($utils);
  }

  override throwIfMissingRequiredInParams (inParams: IWarehouseTransfers_outbound_pick_slip_reportServiceInParams) {
  }

  protected async getData(inParams: IWarehouseTransfers_outbound_pick_slip_reportServiceInParams): Promise<IWarehouseTransfers_outbound_pick_slip_reportServiceData> 
  {
    const $utils = this.$utils;
    const $report: { inParams: IWarehouseTransfers_outbound_pick_slip_reportServiceInParams } = {
      inParams: inParams
    };

    const data: IWarehouseTransfers_outbound_pick_slip_reportServiceData = {
    };
    const datasourcesQueries: (() => Promise<void>)[] = [];

    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId 
      };
      
      const dsData = await this.$datasources.WarehouseTransfers.ds_get_order_owner_contact_top1.get(dsParams);
      
      data.Owner = dsData;
    });
    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId 
      };
      
      const dsData = await this.$datasources.WarehouseTransfers.ds_get_order_ship_to_account_vs_order_address.get(dsParams);
      
      data.ShipTo = dsData;
    });
    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId 
      };
      
      const dsData = await this.$datasources.WarehouseTransfers.ds_outbound_header_pick_slip_report.get(dsParams);
      
      data.PickSlipHeader = dsData;
    });
    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId 
      };
      
      const dsData = await this.$datasources.WarehouseTransfers.ds_outbound_detail_pick_slip_report.get(dsParams);
      
      data.PickSlipDetail = dsData;
    });

    await Promise.all(datasourcesQueries.map(t => t()));

    return data;
  }
}
